"use strict";
/** state: Final **/
/** family: MultiSelect **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var keycode = require("keycode");
var React = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var icon_types_1 = require("../../types/icon.types");
var Checkbox_1 = require("../Checkbox");
var constants_1 = require("../constants");
var Dropdown_1 = require("../Dropdown");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var SafeAnchor_1 = require("../SafeAnchor");
/**
 * Promises are not supported in IE11
 * Therefore a promise polyfill is required to support that browser.
 */
require("promise-polyfill/dist/polyfill");
var CLASS_NAME = 'i-multiselect-list';
/**
 * MultiSelectLists allow the user to select multiple options.
 *
 * Also see {{SingleSelect}} for simple dropdowns
 * – where separators and headings aren't necessary
 * - and {{MultiSelect#MultiSelectButton}} when space is limited.
 */
var MultiSelectList = /** @class */ (function (_super) {
    __extends(MultiSelectList, _super);
    function MultiSelectList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyDown = function (e) {
            var selectedItems = _this.state.selectedItems;
            if (e.keyCode === keycode('Backspace') &&
                !_this.state.value &&
                selectedItems.length > 0) {
                var last_1 = selectedItems.slice(-1)[0];
                _this.setState({
                    selectedItems: selectedItems.filter(function (selectedItem) { return selectedItem.value !== last_1.value; }),
                }, function () {
                    _this.props.onItemCleared &&
                        _this.props.onItemCleared(last_1, _this.state.selectedItems);
                });
            }
            else {
                _this.handleTextChange();
            }
        };
        _this.handleClick = function (event) {
            event && event.preventDefault();
            var input = _this.inputRef;
            input.focus();
            _this.toggleDropdownOpen(event);
        };
        _this.handleTextChange = function () {
            // This timeout ensures that the value change has registered in IE11 before
            // this event is resolved. Otherwise incorrect values are returned.
            setTimeout(function () {
                var val = _this.inputRef.textContent;
                if (_this.isSearchViaAPIEnabled()) {
                    _this.setState({ isOpen: true, value: val, isLoading: true }, function () {
                        _this.changeSubject.next(val);
                    });
                    _this.updateItemsInSelectedSection(true);
                }
                else {
                    var filteredItems = _this.props.items.filter(function (item) {
                        if (val) {
                            return (item.label
                                .toUpperCase()
                                .indexOf(val.toUpperCase()) > -1);
                        }
                        return item;
                    });
                    _this.setState({
                        isOpen: true,
                        items: filteredItems,
                        value: val,
                    });
                }
            });
        };
        _this.toggleDropdownOpen = function (event) {
            var isOpen = !_this.state.isOpen;
            _this.setState({
                isOpen: isOpen,
            });
            _this.updateItemsInSelectedSection(isOpen);
            event && event.stopPropagation();
        };
        // whenever dropdown is open, we need to update "itemsInSelectedSection" with the correct selected items
        _this.updateItemsInSelectedSection = function (isOpen, actualSelectedItems) {
            if (actualSelectedItems === void 0) { actualSelectedItems = _this.state.selectedItems; }
            if (isOpen) {
                _this.setState({
                    itemsInSelectedSection: actualSelectedItems,
                });
            }
        };
        _this.renderLoading = function () {
            return (React.createElement(Dropdown_1.Dropdown.Item, { readOnly: true, key: "loading", className: CLASS_NAME + "--loading" },
                React.createElement(IconWrapper_1.IconWrapper, null,
                    React.createElement(FontAwesome_1.FontAwesome, { name: icon_types_1.Icon.Loading, className: CLASS_NAME + "--loading__icon", size: FontAwesome_1.FontAwesome.Size.X2, spin: true }))));
        };
        _this.isSelected = function (items, item) {
            return !!items.filter(function (selectedItem) { return selectedItem.value === item.value; })
                .length;
        };
        _this.renderItems = function () {
            var _a = _this.state, items = _a.items, itemsInSelectedSection = _a.itemsInSelectedSection, selectedItems = _a.selectedItems;
            if (items.length === 0) {
                return _this.renderNoItemsFoundMessage();
            }
            if (_this.isSearchViaAPIEnabled()) {
                var displayedItems = [];
                var itemsDisplayedInSelectedSection_1 = [];
                var itemsDisplayedInUnselectedSection_1 = [];
                items.forEach(function (item) {
                    var isSelected = _this.isSelected(itemsInSelectedSection, item);
                    if (isSelected) {
                        itemsDisplayedInSelectedSection_1.push(item);
                    }
                    else {
                        itemsDisplayedInUnselectedSection_1.push(item);
                    }
                });
                var hasDivider = itemsDisplayedInSelectedSection_1.length > 0 &&
                    itemsDisplayedInUnselectedSection_1.length > 0;
                if (itemsDisplayedInSelectedSection_1.length > 0) {
                    displayedItems.push.apply(displayedItems, itemsDisplayedInSelectedSection_1.map(function (item, index) {
                        return _this.renderOption(item, index, _this.isSelected(selectedItems, item));
                    }));
                }
                if (hasDivider) {
                    displayedItems.push(_this.renderDivider('divider-search'));
                }
                if (itemsDisplayedInUnselectedSection_1.length > 0) {
                    displayedItems.push.apply(displayedItems, itemsDisplayedInUnselectedSection_1.map(function (item, index) {
                        return _this.renderOption(item, index, _this.isSelected(selectedItems, item));
                    }));
                }
                if (displayedItems.length > 0) {
                    return displayedItems;
                }
                return _this.renderNoItemsFoundMessage();
            }
            return items.map(function (item, index) {
                return _this.renderOption(item, index, _this.isSelected(selectedItems, item));
            });
        };
        _this.renderNoItemsFoundMessage = function () {
            var noItemsFoundMessage = _this.props.noItemsFoundMessage;
            return (React.createElement(Dropdown_1.Dropdown.Item, null,
                React.createElement("span", { className: CLASS_NAME + "--no-items-found" }, noItemsFoundMessage)));
        };
        _this.renderOption = function (item, index, isSelected) {
            return (React.createElement(Dropdown_1.Dropdown.Item, { key: index, onClick: function (e) {
                    _this.handleCheckboxChange(e, __assign({}, item, { checked: !isSelected }));
                } },
                React.createElement(Checkbox_1.Checkbox, { label: item.label, checked: isSelected, value: item.value })));
        };
        _this.handleCheckboxChange = function (_, data) {
            if (data.checked) {
                var actualSelectedItems_1 = _this.state.selectedItems.concat([data]);
                _this.setState({
                    selectedItems: actualSelectedItems_1,
                }, function () {
                    if (_this.props.onItemSelected) {
                        _this.props.onItemSelected(data, actualSelectedItems_1);
                    }
                });
                var input = _this.inputRef;
                input.focus();
            }
            else {
                _this.clearItem(data);
            }
        };
        _this.clearItem = function (item) {
            var actualSelectedItems = _this.state.selectedItems.filter(function (selectedItem) { return selectedItem.value !== item.value; });
            _this.setState({
                selectedItems: actualSelectedItems,
            }, function () {
                if (_this.props.onItemCleared) {
                    _this.props.onItemCleared(item, actualSelectedItems);
                }
                var input = _this.inputRef;
                input.focus();
            });
        };
        _this.handleTagCloseClick = function (event, item) {
            event.stopPropagation();
            _this.clearItem(item);
        };
        _this.renderRepresentation = function () {
            var _a = _this.state, isOpen = _a.isOpen, selectedItems = _a.selectedItems, value = _a.value;
            var placeholder = _this.props.placeholder;
            if (selectedItems.length > 0) {
                return (React.createElement("ul", { className: CLASS_NAME + "__pill-list" }, selectedItems.map(function (item, index) { return (React.createElement(MultiSelectListPill, { closeLabel: _this.props.closeLabel + " " + item.label, key: "item_" + index, onClose: function (e) {
                        _this.handleTagCloseClick(e, item);
                    } }, item.label)); })));
            }
            /**
             * show placeholder when:
             * 1. no items are selected
             * 2. no search text
             * 3. dropdown is not open
             */
            if (placeholder && !value && !isOpen) {
                return (React.createElement("span", { className: CLASS_NAME + "__placeholder" }, placeholder));
            }
        };
        _this.isSearchViaAPIEnabled = function () { return !!_this.props.onSearch; };
        _this.isInSearchMode = function () {
            return _this.isSearchViaAPIEnabled && !!_this.state.value;
        };
        _this.subscribeToChange = function () {
            _this.changeSubject = new rxjs_1.Subject();
            _this.changeSubscription = _this.changeSubject
                .pipe(operators_1.debounceTime(_this.props.debounceTime), operators_1.distinctUntilChanged(), operators_1.switchMap(function (value) { return rxjs_1.from(_this.props.onSearch(value)); }), 
            /**
             * Skip the searchResults returned from the onSearch promise if dropdown is closed.
             *
             * Scenario: input the search keyword and quickly click outside(dropdown will close
             * before the promise returns), at this moment, we don't want to set the searchResults
             * to the state.
             */
            operators_1.filter(function () { return _this.state.isOpen; }))
                .subscribe(function (searchResults) {
                _this.setState({ items: searchResults, isLoading: false });
            });
        };
        _this.unsubscribeFromChange = function () {
            _this.changeSubscription.unsubscribe();
        };
        _this.renderDivider = function (key) { return (React.createElement(Dropdown_1.Dropdown.Item, { divider: true, key: key })); };
        _this.state = {
            isLoading: false,
            isOpen: props.isOpen,
            items: props.items,
            itemsInSelectedSection: props.selectedItems,
            selectedItems: props.selectedItems,
            value: '',
        };
        return _this;
    }
    MultiSelectList.prototype.componentDidMount = function () {
        if (this.isSearchViaAPIEnabled()) {
            this.subscribeToChange();
        }
    };
    MultiSelectList.prototype.componentWillUnmount = function () {
        if (this.isSearchViaAPIEnabled()) {
            this.unsubscribeFromChange();
        }
    };
    MultiSelectList.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.isOpen !== this.props.isOpen) {
            this.setState({
                isOpen: nextProps.isOpen,
            });
            this.updateItemsInSelectedSection(nextProps.isOpen, nextProps.selectedItems);
        }
        // in search mode, items are the search results, it should not be overwritten by props
        if (!this.isInSearchMode()) {
            this.setState({
                items: nextProps.items,
            });
        }
        this.setState({
            selectedItems: nextProps.selectedItems,
        });
    };
    MultiSelectList.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, closeLabel = _a.closeLabel, debounceTimeFromProps = _a.debounceTime, isOpen = _a.isOpen, items = _a.items, noItemsFoundMessage = _a.noItemsFoundMessage, onItemCleared = _a.onItemCleared, onItemSelected = _a.onItemSelected, onSearch = _a.onSearch, selectedItems = _a.selectedItems, placeholder = _a.placeholder, restProps = __rest(_a, ["className", "closeLabel", "debounceTime", "isOpen", "items", "noItemsFoundMessage", "onItemCleared", "onItemSelected", "onSearch", "selectedItems", "placeholder"]);
        return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, className), onKeyDown: this.handleKeyDown }, restProps),
            React.createElement(Dropdown_1.Dropdown, { id: this.props.id + "_dropdown", role: Dropdown_1.Dropdown.Role.ListBox, isOpen: this.state.isOpen, onOutsideClick: function () {
                    _this.setState({
                        isLoading: false,
                        isOpen: false,
                        items: items,
                        value: '',
                    });
                    var input = _this.inputRef;
                    input.textContent = '';
                }, toggle: React.createElement("div", { className: classNames('tag-container', 'form-control', {
                        'tag-container--dropdown-open': this.state
                            .isOpen,
                    }), onClick: this.handleClick },
                    this.renderRepresentation(),
                    React.createElement("span", { className: CLASS_NAME + "__input", contentEditable: true, role: "textbox", id: this.props.id + "_text", onInput: this.handleTextChange, onClick: this.toggleDropdownOpen, ref: function (el) { return (_this.inputRef = el); }, tabIndex: 0 }),
                    this.isSearchViaAPIEnabled() && (React.createElement(IconWrapper_1.IconWrapper, null,
                        React.createElement(FontAwesome_1.FontAwesome, { name: icon_types_1.Icon.Search, className: CLASS_NAME + "__search__icon" })))) }, this.state.isLoading
                ? this.renderLoading()
                : this.renderItems())));
    };
    MultiSelectList.defaultProps = {
        debounceTime: constants_1.DEFAULT_DEBOUNCE_TIME,
        selectedItems: [],
    };
    return MultiSelectList;
}(React.Component));
exports.MultiSelectList = MultiSelectList;
var onCloseIconKeypress = function (e, onClose) {
    if (e.keyCode === keycode('Enter') || e.keyCode === keycode('Space')) {
        onClose(e);
    }
};
var PILL_CLASS_NAME = CLASS_NAME + "__pill";
/**
 * The base implementation for a pill item.
 */
var MultiSelectListPill = function (_a) {
    var children = _a.children, className = _a.className, closeLabel = _a.closeLabel, iconName = _a.iconName, onClose = _a.onClose, restProps = __rest(_a, ["children", "className", "closeLabel", "iconName", "onClose"]);
    return (React.createElement("li", __assign({ className: classNames(PILL_CLASS_NAME, className) }, restProps),
        iconName && (React.createElement("span", { className: PILL_CLASS_NAME + "__icon" },
            React.createElement(IconWrapper_1.IconWrapper, null,
                React.createElement(FontAwesome_1.FontAwesome, { name: iconName })))),
        children,
        !!closeLabel && (React.createElement(SafeAnchor_1.SafeAnchor, { "aria-label": closeLabel, className: classNames(PILL_CLASS_NAME + "__close", 'close'), onClick: onClose, type: "button", onKeyDown: function (e) {
                return onCloseIconKeypress(e, onClose);
            } },
            React.createElement("span", { "aria-hidden": true }, "\u00D7")))));
};
//# sourceMappingURL=MultiSelectList.js.map